
import Body from './body'
import BottomContext from './bottom'
const TempleteSeven = () => {
    return <>
        <Body></Body>
        <BottomContext></BottomContext>
    </>
}

export default TempleteSeven